import { render, staticRenderFns } from "./CurrentTeachers.vue?vue&type=template&id=72e7bd43&"
import script from "./CurrentTeachers.vue?vue&type=script&lang=js&"
export * from "./CurrentTeachers.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTeachers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurrentTeachers.vue"
export default component.exports